var exist_ids = [];
var $url_search = document.querySelector('html').getAttribute('lang');
var lang = document.querySelector('html').getAttribute('lang');

if ($url_search === 'tr') {
  $url_search = ''
} else {
  $url_search = `${$url_search}/`;
}

var search_trans = {
  'search_placeholder': 'Search for a Project',
  'searching': 'Searching...',
  'search_noresults': 'No Results',
}

if (lang === 'ar') {
  search_trans = {
    'search_placeholder': 'ابحث عن مشروع',
    'searching': 'جاري البحث...',
    'search_noresults': 'لا يوجد نتائج',
  }
} else if (lang === 'fa') {
  search_trans = {
    'search_placeholder': 'جستجوی پروژه',
    'searching': 'جستجوکردن...',
    'search_noresults': 'هیچ نتیجه ای',
  }
} else if (lang === 'tr') {
  search_trans = {
    'search_placeholder': 'Proje ara',
    'searching': 'Aranıyor...',
    'search_noresults': 'sonuç yok',
  }
}

// The autoComplete.js Engine instance creator
const autoCompletejs = new autoComplete({
  data: {
    src: async () => {
      // Loading placeholder text
      document.querySelector("#webAutoComplete").setAttribute("placeholder", `${search_trans.searching}`);
      // Fetch External Data Source
      const query = document.querySelector("#webAutoComplete").value;
      const source = await fetch(`/${$url_search}search?key=${query}`);
      const data = await source.json();

      // Post loading placeholder text
      document.querySelector("#webAutoComplete").setAttribute("placeholder", `${search_trans.search_placeholder}`);

      // Returns Fetched data
      return data;
    },
    key: ["title", "rooms", "city", "region"],
    cache: false
  },
  sort: (a, b) => {
    if (a.match < b.match) return -1;
    if (a.match > b.match) return 1;
    return 0;
  },
  placeHolder: `${search_trans.search_placeholder}`,
  selector: "#webAutoComplete",
  threshold: 2,
  debounce: 500,
  searchEngine: "strict",
  highlight: true,
  maxResults: 20,
  resultsList: {
    render: true,
    container: source => {
      source.setAttribute("id", "autoComplete_list");
    },
    destination: document.querySelector("#webAutoComplete"),
    position: "afterend",
    element: "ul"
  },
  query: {
    manipulate: function (query) {
      exist_ids = [];
      return query;
    }
  },
  resultItem: {
    content: (data, source) => {
      source.innerHTML = data.match;

      if (exist_ids.indexOf(data.value.id) == -1) {
        exist_ids.push(data.value.id);
      } else {
        source.style.display = 'none';
      }

      var project_details = `
      <a href="${data.value.url}">
        <div class="result">
            <div class="project-img">
                <img src="${data.value.image}" alt="Project Image">
            </div>
            <div class="project-info">
                <div class="project-name">
                    <span>${data.value.title}</span>
                </div>
                <div class="project-details">
                    <div class="project-location"><i class="fas fa-map-marker-alt"></i> <span class="ml-2">${data.value.city},</span> &nbsp;<span> ${data.value.region}</span></div>
                    <div class="project-rooms ml-2 ml-sm-3 ml-lg-5"><img src="../../assets/img/white-bed.svg">  <span class="ml-2">${data.value.rooms}</span></div>
                </div>
            </div>
        </div>
      </a>
        `;

      source.innerHTML = project_details.replace(data.value[data.key], data.match);
    },
    element: "li"
  },
  noResults: () => {
    const result = document.createElement("li");
    result.setAttribute("class", "no_result");
    result.setAttribute("tabindex", "1");
    result.innerHTML = `${search_trans.search_noresults}`;
    document.querySelector("#autoComplete_list").appendChild(result);
  },
  onSelection: feedback => {
    const selection = feedback.selection.value.project_name;
    // Render selected choice to selection div
    document.querySelector(".selection").innerHTML = selection;
    // Clear Input
    document.querySelector("#webAutoComplete").value = "";
    // Change placeholder with the selected value
    document.querySelector("#webAutoComplete").setAttribute("placeholder", selection);
  }
});